import { useState, useRef, useEffect } from "react";
import { Printer, FileText, FileDown, FileSearch, Download, ChevronDown } from "lucide-react";
import { exportQuickPDF, exportFullDebatePDF, exportExecutiveSummaryPDF } from "../lib/exportPdf";

/**
 * Export menu dropdown for a discussion.
 * Offers: Print (browser), Quick PDF, Full Debate PDF, Executive Summary PDF.
 * All PDF generation is client-side (jsPDF) — no server cost.
 */
export const ExportMenu = ({ discussion, className = "" }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const run = (fn) => {
    setOpen(false);
    try {
      fn(discussion);
    } catch (err) {
      console.error("[Export] failed:", err);
    }
  };

  const items = [
    { id: "print", label: "Print", icon: Printer, onClick: () => { setOpen(false); window.print(); } },
    { id: "quick", label: "Quick PDF (Synthese + Verificatie)", icon: FileText, onClick: () => run(exportQuickPDF) },
    { id: "full", label: "Volledig Debat (PDF)", icon: FileDown, onClick: () => run(exportFullDebatePDF) },
    { id: "exec", label: "Executive Summary (PDF)", icon: FileSearch, onClick: () => run(exportExecutiveSummaryPDF) },
  ];

  return (
    <div ref={ref} className={`relative inline-block no-print ${className}`}>
      <button onClick={() => setOpen(v => !v)}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 border border-[#E5E5E5] text-xs font-bold text-[#52525B] hover:border-[#2d8cf0] hover:text-[#2d8cf0] transition-colors"
        data-testid="export-menu-btn"
        title="Print of download als PDF"
      >
        <Download className="w-3.5 h-3.5" /> Exporteer <ChevronDown className="w-3 h-3" />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 z-30 w-64 bg-white border border-[#E5E5E5] shadow-lg" data-testid="export-menu">
          {items.map(item => (
            <button key={item.id} onClick={item.onClick}
              className="w-full flex items-center gap-2 px-3 py-2.5 text-xs text-left hover:bg-gray-50 border-b border-gray-100 last:border-0"
              data-testid={`export-${item.id}`}
            >
              <item.icon className="w-3.5 h-3.5 text-[#52525B] flex-shrink-0" />
              <span>{item.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
